import { render, staticRenderFns } from "./merge-content.vue?vue&type=template&id=31d2ac1e&scoped=true&"
import script from "./merge-content.vue?vue&type=script&lang=js&"
export * from "./merge-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d2ac1e",
  null
  
)

export default component.exports